import { Button, CircularProgress, Typography } from "@material-ui/core";
import DeleteOutlineIcon from "@material-ui/icons/DeleteOutline";
import { mdiArrowLeft } from "@mdi/js";
import AlertModal from "components/AlertModal";
import { concat, find, get, includes, isNil, size } from "lodash";
import React from "react";
import { useTranslation } from "react-i18next";
import { connect } from "react-redux";
import { useHistory } from "react-router-dom";
import * as images from "assets";
import CustomAvatar from "components/CustomAvatar";
import CustomBadge from "components/CustomBadge";
import CustomTable from "components/CustomTable";
import LoadingBox from "components/LoadingBox";
import { StateBox } from "components/TableComponents";
import { WORKPLACE_TYPES } from "constants/constants";
import {
  CustomEventDispose,
  CustomEventListener,
  DELETE_TRASH_PROJECT,
  DELETE_TRASH_PROJECT_FAIL,
} from "constants/events";
import { decodePriorityCode } from "helpers/project/commonHelpers";
import HeaderTableAllGroup from "./components/HeaderTableAllGroup";
import "./style.scss";
import DeleteTable from "./components/TableBody";

const Container = ({ className = "", ...props }) => (
  <div
    className={`view_ProjectGroupPage_Table_Deleted___container ${className}`}
    {...props}
  />
);

const MyButton = ({
  className = "",
  disabled = false,
  isDel = false,
  ...props
}) => (
  <Button
    variant="outlined"
    className={`view_ProjectGroupPage_Table_Deleted___button${
      isDel ? "-delete" : ""
    }${disabled ? "-disabled" : ""} ${className}`}
    disabled={disabled}
    {...props}
  />
);

const ButtonWrapper = ({ className = "", ...props }) => (
  <div
    className={`view_ProjectGroupPage_Table_Deleted___button-wrapper ${className}`}
    {...props}
  />
);

function DeletedProjectTable({
  expand,
  handleExpand,
  route,
  projects,
  pendings,
  projectGroup, // ko sai
  handleSortType, // ko sai
  handleDelete, // ko sai
  handleRestore,
}) {
  const { t } = useTranslation();
  const [alertConfirm, showAlertConfirm] = React.useState(false);
  const [selectedRow, setSelectedRow] = React.useState(null);
  const [loading, setLoading] = React.useState(false);
  const [title, setTitle] = React.useState(
    t("LABEL_ALL_DELETED_WORKING_BOARD")
  );

  const [newProjects, setNewProjects] = React.useState(projects);
  const [search, setSearch] = React.useState("");

  React.useEffect(() => {
    setNewProjects({
      ...projects,
    });
  }, [projects]);

  // const handleSearch = (search) => {
  //   if (!!search) {
  //     setNewProjects({
  //       ...projects,
  //       projects: [
  //         ...projects.projects.filter((item) => {
  //           let inSearch = false;
  //           for (const key in item) {
  //             if (
  //               item.hasOwnProperty(key) &&
  //               get(item, key, "") &&
  //               includes(get(item, key, "").toString().toLowerCase(), search)
  //             ) {
  //               inSearch = true;
  //               break;
  //             } else {
  //               inSearch = false;
  //             }
  //           }
  //           return inSearch;
  //         }),
  //       ],
  //     });
  //   } else {
  //     setNewProjects({
  //       ...projects,
  //     });
  //   }
  // };
  React.useEffect(() => {
    const handleSearch = (search) => {
      setNewProjects({
        ...projects,
        projects: [
          ...projects.projects.filter((item) => {
            let inSearch = false;
            for (const key in item) {
              if (
                item.hasOwnProperty(key) &&
                get(item, key, "") &&
                includes(get(item, key, "").toString().toLowerCase(), search)
              ) {
                inSearch = true;
                break;
              } else {
                inSearch = false;
              }
            }
            return inSearch;
          }),
        ],
      });
    };
    if (!!search) {
      handleSearch(search);
    } else {
      setNewProjects({
        ...projects,
      });
    }
  }, [projects, search]);

  React.useEffect(() => {
    const resetConfirm = () => {
      showAlertConfirm(false);
      setLoading(false);
    };
    CustomEventListener(DELETE_TRASH_PROJECT, resetConfirm);
    CustomEventListener(DELETE_TRASH_PROJECT_FAIL, resetConfirm);
    return () => {
      CustomEventDispose(DELETE_TRASH_PROJECT, resetConfirm);
      CustomEventDispose(DELETE_TRASH_PROJECT_FAIL, resetConfirm);
    };
  }, [loading]);
  function resolveTitle() {
    return (
      <>
        <DeleteOutlineIcon fontSize={"large"} style={{ marginRight: 20 }} />
        <Typography variant={"h5"} bold>
          {title}
        </Typography>
      </>
    );
  }
  console.log(pendings, projectGroup, projects, newProjects);
  return (
    <Container>
      <HeaderTableAllGroup
        route={route}
        search={search}
        expand={expand}
        onExpand={handleExpand}
        onSearch={setSearch}
      />
      {newProjects.loading && <LoadingBox />}
      {size(newProjects?.projects) > 0 && !newProjects.loading && (
        <div>
          <DeleteTable
            data={newProjects?.projects ?? []}
            pendings={pendings}
            handleRestore={handleRestore}
          />
        </div>
      )}
      <AlertModal
        open={alertConfirm}
        setOpen={showAlertConfirm}
        content={t("DMH.VIEW.PGP.RIGHT.ALL.ALERT")}
        onConfirm={() => {
          setLoading(true);
          handleDelete(get(selectedRow, "id"));
        }}
        onCancle={() => {
          showAlertConfirm(false);
          setLoading(false);
        }}
        manualClose={true}
        actionLoading={loading}
      />
    </Container>
  );
}
export default connect(
  (state) => ({
    projectGroup: get(
      state.projectGroup.listProjectGroupDeleted.data,
      "projectGroups",
      []
    ),
  }),
  {}
)(DeletedProjectTable);
